import { useState, useEffect } from "react";
import Loading from "./Loading";

export const LoadingWithMessages = ({ messages, intervalMs = 1800 }) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    if (!messages || messages.length === 0) return;

    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, intervalMs);

    return () => clearInterval(interval);
  }, [messages, messages.length, intervalMs]);

  // Si no hay mensajes, podemos omitir el renderizado del texto
  const currentMessage =
    messages?.length > 0 ? messages[currentMessageIndex] : "";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "90%",
        width: "100%",
        minHeight: 250
      }}
    >
      <Loading />
      {currentMessage && (
        <p
          className="mt-4 text-center"
          style={{ maxWidth: 500, fontSize: "1.1rem" }}
        >
          {currentMessage}
        </p>
      )}
    </div>
  );
};
